<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      shopId: 'seat/getShopId',
      language: 'setting/getLanguage',
      shouldUpdate: 'menu/getShouldUpdate',
    }),
  },
  watch: {
    shopId(shopId) {
      if (shopId !== null) {
        this.fetchMenu()
      }
    },
    language() {
      if (this.shopId) {
        this.fetchMenu(true)
      }
    },
    async shouldUpdate(bool) {
      if (bool) {
        this.setShouldUpdate(false)
        await this.fetchMenu()
      }
    },
  },
  methods: {
    ...mapActions({
      fetchMenu: 'menu/fetchMenu',
      setShouldUpdate: 'menu/setShouldUpdate',
    }),
  },
  render(h) {
    return h() // avoid empty template warning message
  },
}
</script>
